export function offersNav() {
	let $offersNav = $(".offers-nav");
	let $offersPhoto = $offersNav.find(".photo");
	let $offersDescription = $(".offers-description .item");

	$offersNav.find("a").on("click", function (e) {
		e.preventDefault();
		let parent = $(this).parent("li");
		let i = parent.index();
		$offersNav.find("li").removeClass("active");
		parent.addClass("active");
		$offersDescription.removeClass("active");
		$offersDescription.eq(i).addClass("active");
		$offersPhoto.removeClass("active");
		$offersPhoto.eq(i).addClass("active");
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/offersNav.js